(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cb-bundle-offer"] && !Shopify.designMode) return;
  try {
    if (window.customElements && !window.customElements.get('cb-bundle-offer')) {
    window.customElements.define(
      'cb-bundle-offer',
      class extends HTMLElement {
        connectedCallback() {
          this.onChange = this.onChange.bind(this);
          this.onQty = this.onQty.bind(this);
          this.onSelect = this.onSelect.bind(this);
          this.onSubmit = this.onSubmit.bind(this);
          this.touched = false;
          this.addEventListener('change', this.onChange);
          document.addEventListener('quantity-selector:update', this.onQty);
          document.addEventListener('shopify:product:select', this.onSelect);
          // Window capture runs before Horizon's document-level submit handler, so a mixed
          // pack can take over Add to cart (the sticky bar clicks the same button).
          window.addEventListener('submit', this.onSubmit, true);

          this.paintDots();
          if (this.dataset.size) this.setSize(this.dataset.size, false);
          var pre = parseInt(this.dataset.preselect, 10) || 1;
          var checked = this.querySelector('.cb-bo__input:checked');
          var input = this.qtyInput();
          var current = input ? parseInt(input.value, 10) || 1 : 1;
          if (pre > 1 && checked && current === 1) {
            // Preselected bundle: push its quantity into the selector once on load.
            this.apply(parseInt(checked.value, 10) || 1);
          } else {
            this.mark(current);
          }
          // The Add to cart button sits below this block; sync again once it exists.
          var self = this;
          setTimeout(function () {
            self.syncAtc();
          }, 0);
          setTimeout(function () {
            self.warmStacks();
          }, 2500);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
          document.removeEventListener('quantity-selector:update', this.onQty);
          document.removeEventListener('shopify:product:select', this.onSelect);
          window.removeEventListener('submit', this.onSubmit, true);
        }

        // Horizon redraws the Add to cart button and the sticky bar after a variant change;
        // put the total back, and move untouched picks to the newly selected color.
        onSelect(event) {
          var self = this;
          var done = function (result) {
            setTimeout(function () {
              var id = result && result.variant && result.variant.id;
              id = id ? String(id).split('/').pop() : self.formVariantId();
              if (id) {
                self.setUnitOne(id);
                self.setArt(id);
              }
              if (!self.touched && id) self.setAllPicks(id);
              self.syncAtc();
            }, 60);
          };
          if (event && event.promise && typeof event.promise.then === 'function') {
            event.promise.then(done, function () {
              done(null);
            });
          } else {
            done(null);
          }
        }

        // The main Add to cart button's tail: an arrow ("Add to cart →"), plus the selected
        // bundle's real total when "Show the selected total inside Add to cart" is on. Since
        // 2026-10-12 it is off: the picked pack row right above shows the price.
        syncAtc() {
          this.syncMix();
          var btn = this.scope().querySelector('product-form-component .button[id^="BuyButtons-ProductSubmitButton-"]');
          if (!btn) return;
          var showTotal = this.dataset.atcTotal === 'true';
          var tag = btn.querySelector('.cb-atc-total');
          var checked = this.querySelector('.cb-bo__input:checked');
          var total = checked ? checked.closest('.cb-bo__card').querySelector('.cb-bo__total') : null;
          if (btn.disabled || (showTotal && !total)) {
            if (tag) tag.remove();
            return;
          }
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'cb-atc-total';
            var added = btn.querySelector('.add-to-cart__added');
            btn.insertBefore(tag, added || null);
          }
          tag.textContent = showTotal ? total.textContent.trim() : '';
        }

        scope() {
          return this.closest('.shopify-section') || document;
        }

        selector() {
          return this.scope().querySelector('product-form-component quantity-selector-component') ||
            this.scope().querySelector('quantity-selector-component');
        }

        qtyInput() {
          var sel = this.selector();
          return sel ? sel.querySelector('input[name="quantity"]') : null;
        }

        formVariantId() {
          var id = this.scope().querySelector('product-form-component input[name="id"]');
          return id ? id.value : '';
        }

        onChange(event) {
          var target = event.target;
          if (target && target.classList && target.classList.contains('cb-size__input')) {
            this.setSize(target.value, true);
            this.syncMix();
            return;
          }
          if (target && target.classList && target.classList.contains('cb-bo__size-select')) {
            this.setUnitSize(target);
            return;
          }
          if (target && target.classList && target.classList.contains('cb-colors__input')) {
            // The image swatches above the packs (2026-10-13): every unit in every row takes the colour; the
            // gallery stays put.
            this.setAllPicks(target.value);
            this.setArt(target.value);
            var picked = this.querySelector('[data-cb-color-name]');
            if (picked) picked.textContent = target.getAttribute('data-option') || '';
            this.showColorPhoto(target.getAttribute('data-option'));
            this.touched = false;
            this.paintDots();
            this.syncMix();
            return;
          }
          if (target && target.classList && target.classList.contains('cb-bo__pick-select')) {
            if (target.getAttribute('data-unit-n') === '1' && this.classList.contains('cb-bo--rows')) {
              // Rows (2026-10-12): each menu is independent and the URL keeps no ?variant=; only the
              // 1-pack photo follows unit 1. Add to cart sends the picks as explicit lines (mixLines).
              this.setArt(target.value);
            }
            this.touched = true;
            this.paintDots();
            this.syncMix();
            return;
          }
          if (target && target.classList && target.classList.contains('cb-bo__swatch-input')) {
            var unit = target.closest('[data-unit]');
            if (unit && unit.getAttribute('data-unit') === '1') {
              // Unit 1 is the product's color: sync every pack's unit 1, the art, the gallery.
              this.setUnitOne(target.value);
              this.setArt(target.value);
              if (!this.touched) this.setAllPicks(target.value);
              this.driveVariant(target.getAttribute('data-option'));
            } else {
              this.touched = true;
            }
            this.syncMix();
            return;
          }
          if (!target || target.type !== 'radio' || !target.classList.contains('cb-bo__input')) return;
          this.apply(parseInt(target.value, 10) || 1);
          var item = target.closest('.cb-bo__item');
          if (item && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            item.classList.remove('cb-bo__item--pop');
            void item.offsetWidth;
            item.classList.add('cb-bo__item--pop');
          }
        }

        apply(qty) {
          var sel = this.selector();
          if (sel && typeof sel.setValue === 'function') {
            sel.setValue(String(qty));
            if (typeof sel.onQuantityChange === 'function') sel.onQuantityChange();
            if (typeof sel.updateButtonStates === 'function') sel.updateButtonStates();
          } else {
            var input = this.qtyInput() || this.scope().querySelector('input[name="quantity"]');
            if (input) {
              input.value = String(qty);
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          this.mark(qty);
        }

        // Follow the + / - buttons, but only for this section's own selector.
        onQty(event) {
          if (!event.detail || event.detail.cartLine) return;
          var target = event.target;
          if (!(target instanceof Node) || !this.scope().contains(target)) return;
          this.mark(event.detail.quantity);
        }

        mark(qty) {
          this.querySelectorAll('.cb-bo__input').forEach(function (radio) {
            radio.checked = parseInt(radio.value, 10) === qty;
          });
          this.syncAtc();
        }

        /* ---------- Sizes (2026-10-13) ---------- */

        // The size row's data (rendered next to it): each size's price, its price after the sale, its fit, and
        // the variant id of every colour in it.
        sizeData() {
          if (this.sizes === undefined) {
            var el = this.querySelector('script[data-cb-sizes]');
            try {
              this.sizes = el ? JSON.parse(el.textContent) : null;
            } catch (e) {
              this.sizes = null;
            }
          }
          return this.sizes;
        }

        // Cents as the store prints money; short drops ".00" (the theme's money_without_trailing_zeros).
        money(cents, short) {
          var data = this.sizeData() || {};
          var parts = (Math.round(cents) / 100).toFixed(2).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          var text = short && parts[1] === '00' ? parts[0] : parts.join('.');
          var fmt = String(data.money || '').replace(/<[^>]*>/g, '');
          return fmt ? fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, text) : '$' + text;
        }

        // A size picked: every colour pick moves to its variant in that size (a colour sold out in it is hidden),
        // the rows, struck prices, "You save" and the sticky bar take the size's prices, and (drive) Horizon's
        // hidden picker selects the size, so the gallery, URL and form follow.
        setSize(name, drive) {
          var data = this.sizeData();
          var size = null;
          (data && data.sizes || []).forEach(function (z) {
            if (z.name === name) size = z;
          });
          if (!size) return;
          this.dataset.size = name;
          var nameEl = this.querySelector('[data-cb-size-name]');
          if (nameEl) nameEl.textContent = name;
          var fitsEl = this.querySelector('[data-cb-size-fits]');
          if (fitsEl) fitsEl.textContent = size.fits || '';
          var dimsEl = this.querySelector('[data-cb-size-dims]');
          if (dimsEl) dimsEl.textContent = size.dims || '';
          this.querySelectorAll('.cb-bo__pick-select').forEach(function (select) {
            var was = select.options[select.selectedIndex];
            var keep = was ? was.getAttribute('data-option') : '';
            Array.prototype.forEach.call(select.options, function (opt) {
              var v = size.ids[opt.getAttribute('data-option')];
              if (v) opt.value = String(v.id);
              opt.disabled = !(v && v.ok);
              opt.hidden = opt.disabled;
            });
            var opts = Array.prototype.slice.call(select.options);
            var pick = opts.filter(function (o) {
              return !o.disabled && o.getAttribute('data-option') === keep;
            })[0] || opts.filter(function (o) {
              return !o.disabled;
            })[0];
            if (pick) select.value = pick.value;
          });
          this.querySelectorAll('.cb-bo__swatch-input').forEach(function (input) {
            var v = size.ids[input.getAttribute('data-option')];
            if (v) input.value = String(v.id);
            input.disabled = !(v && v.ok);
            var label = input.closest('.cb-bo__swatch');
            if (label) label.hidden = input.disabled;
          });
          this.querySelectorAll('[data-unit]').forEach(function (unit) {
            var on = unit.querySelector('.cb-bo__swatch-input:checked');
            if (on && !on.disabled) return;
            var first = unit.querySelector('.cb-bo__swatch-input:not(:disabled)');
            if (first) first.checked = true;
          });
          // The size row sets every unit; a unit's own menu can change it after.
          this.querySelectorAll('.cb-bo__size-select').forEach(function (select) {
            select.value = name;
          });
          this.paintSizePrices(size, data);
          var one = this.querySelector('.cb-bo__pick-select[data-unit-n="1"]') ||
            this.querySelector('[data-unit="1"] .cb-bo__swatch-input:checked');
          if (one) this.setArt(one.value);
          // The form adds the picked size at once (Horizon's own picker catches up when it has redrawn); with one
          // colour there are no menus to carry it.
          var formId = this.scope().querySelector('product-form-component input[name="id"]');
          var ids = Object.keys(size.ids).map(function (k) {
            return size.ids[k];
          });
          var pick = one ? one.value : ids.length ? String(ids[0].id) : '';
          if (formId && pick && formId.value !== pick) formId.value = pick;
          this.paintDots();
          this.syncAtc();
          if (drive) this.driveVariant(name);
        }

        paintSizePrices(size, data) {
          var self = this;
          var sale = !!data.sale && size.after > size.price;
          if (sale) this.dataset.wasSingle = this.money(size.after);
          else delete this.dataset.wasSingle;
          this.querySelectorAll('.cb-bo__item').forEach(function (item) {
            self.paintItem(item, size, data);
          });
          // The price row under the title (blocks/cb-launch-price.liquid) shows the size's price, its struck price
          // after the sale and the percent off (rounded down, as there).
          var scope = this.scope();
          scope.querySelectorAll('.cb-launch__price, .cb-launch__now').forEach(function (el) {
            el.textContent = self.money(size.price);
          });
          scope.querySelectorAll('.cb-launch__was, .cb-launch__after').forEach(function (el) {
            var s = el.querySelector('s');
            if (s && sale) s.textContent = self.money(size.after);
            el.hidden = !sale;
          });
          var pct = sale ? Math.floor((size.after - size.price) * 100 / size.after) : 0;
          scope.querySelectorAll('.cb-launch__pill, .cb-launch__title strong').forEach(function (el) {
            el.hidden = !sale;
            Array.prototype.forEach.call(el.childNodes, function (n) {
              if (n.nodeType === 3 && /\d+%/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\d+%/, pct + '%');
            });
          });
        }

        sizeNamed(name) {
          var data = this.sizeData();
          return (data && data.sizes || []).filter(function (z) {
            return z.name === name;
          })[0] || null;
        }

        // A pack's units' sizes: each unit's own menu, or the size row's size.
        unitSizes(item) {
          var top = this.sizeNamed(this.dataset.size);
          var input = item ? item.querySelector('.cb-bo__input') : null;
          var qty = input ? parseInt(input.value, 10) || 1 : 1;
          var out = [];
          for (var n = 1; n <= qty; n++) {
            var select = item.querySelector('.cb-bo__size-select[data-unit-n="' + n + '"]');
            out.push((select && this.sizeNamed(select.value)) || top);
          }
          return out;
        }

        // A pack row's prices from its units' sizes: the units' prices less the pack's percent (Shopify's
        // percentage discount on the units' total), struck at the units' prices after the sale while it runs.
        paintItem(item, size, data) {
          var self = this;
          var m = /cb-bo__item--t(\d)/.exec(item.className);
          var i = m ? parseInt(m[1], 10) : 1;
          var units = this.unitSizes(item).filter(Boolean);
          var qty = units.length || 1;
          var sale = !!data.sale && size.after > size.price;
          var reg = 0;
          var after = 0;
          units.forEach(function (z) {
            reg += z.price;
            after += z.after > z.price ? z.after : z.price;
          });
          var cut = (data.cut || [])[i - 1] || 0;
          var save = qty === 1 ? 0 : data.mode === 'percent' ? Math.round(reg * cut / 100) : cut;
          if (data.mode === 'bogo') {
            // Buy 1 Get 1 Free: the cheaper half of the pack is free (Shopify's Buy X Get Y frees the cheaper unit).
            save = units.map(function (z) {
              return z.price;
            }).sort(function (a, b) {
              return a - b;
            }).slice(0, Math.floor(qty / 2)).reduce(function (a, b) {
              return a + b;
            }, 0);
          }
          var total = reg - save;
          // While the sale runs, the struck price is the units at their prices after the sale (as in Liquid).
          var anchor = sale ? after : reg;
          var shown = anchor - total;
          var totalEl = item.querySelector('.cb-bo__total');
          if (totalEl) totalEl.textContent = self.money(total);
          var regEl = item.querySelector('.cb-bo__regular');
          if (regEl) {
            regEl.hidden = !(shown > 0);
            var s = regEl.querySelector('s');
            if (s) s.textContent = self.money(anchor);
          }
          var txt = item.querySelector('.cb-bo__save-txt');
          if (txt) {
            txt.textContent = 'You save ' + self.money(shown, true);
            var sub = txt.closest('.cb-bo__sub');
            if (sub) sub.hidden = !(shown > 0);
          }
          var pill = item.querySelector('.cb-bo__save');
          if (pill) pill.textContent = 'Save ' + self.money(shown, true);
          // The row's "SAVE X%" pill: its saving against its struck price, rounded down (as in Liquid).
          var pct = item.querySelector('[data-cb-pct]');
          if (pct) {
            var p = shown > 0 && anchor > 0 ? Math.floor(Math.round(shown) * 100 / Math.round(anchor)) : 0;
            pct.textContent = 'Save ' + p + '%';
            pct.hidden = !(p > 0);
          }
          var each = item.querySelector('[data-cb-each]');
          if (each) each.textContent = self.money(Math.floor(total / qty)) + ' each';
          var card = item.querySelector('.cb-bo__card');
          if (card && qty > 1 && shown > 0) card.setAttribute('data-cb-save', self.money(shown, true));
          else if (card) card.removeAttribute('data-cb-save');
        }

        // One unit's size menu: its color menu (or swatches) moves to that size's variants and the pack reprices.
        setUnitSize(select) {
          var item = select.closest('.cb-bo__item');
          var size = this.sizeNamed(select.value);
          var data = this.sizeData();
          if (!item || !size || !data) return;
          var n = select.getAttribute('data-unit-n');
          var color = item.querySelector('.cb-bo__pick-select[data-unit-n="' + n + '"]');
          var opts = color ? Array.prototype.slice.call(color.options) : [];
          var keep = color && color.options[color.selectedIndex] ? color.options[color.selectedIndex].getAttribute('data-option') : '';
          opts.forEach(function (opt) {
            var v = size.ids[opt.getAttribute('data-option')];
            if (v) opt.value = String(v.id);
            opt.disabled = !(v && v.ok);
            opt.hidden = opt.disabled;
          });
          var pick = opts.filter(function (o) {
            return !o.disabled && o.getAttribute('data-option') === keep;
          })[0] || opts.filter(function (o) {
            return !o.disabled;
          })[0];
          if (pick) color.value = pick.value;
          var unit = item.querySelector('[data-unit="' + n + '"]');
          if (unit) {
            unit.querySelectorAll('.cb-bo__swatch-input').forEach(function (input) {
              var v = size.ids[input.getAttribute('data-option')];
              if (v) input.value = String(v.id);
              input.disabled = !(v && v.ok);
              var label = input.closest('.cb-bo__swatch');
              if (label) label.hidden = input.disabled;
            });
          }
          this.touched = true;
          this.paintItem(item, this.sizeNamed(this.dataset.size) || size, data);
          this.paintDots();
          this.syncMix();
          this.syncAtc();
        }

        // The variant id of a unit with no color menu: the size's only (or first) color.
        sizeVariant(name) {
          var z = this.sizeNamed(name);
          if (!z) return '';
          var keys = Object.keys(z.ids);
          return keys.length ? String(z.ids[keys[0]].id) : '';
        }

        // 2026-10-14 (15 of 19 colour stores switch the main photo on a colour tap): the gallery moves to the colour's
        // photo, the first slide whose alt text starts with the colour's name (as the gallery's colour rule reads it),
        // and keeps its order (the gallery is fixed: data-cb-fixed-order).
        showColorPhoto(name) {
          var want = String(name || '').trim().toLowerCase();
          var gallery = this.scope().querySelector('media-gallery') || document.querySelector('media-gallery');
          var show = gallery && gallery.slideshow;
          if (!want || !show || !show.slides || typeof show.select !== 'function') return;
          var index = -1;
          show.slides.some(function (slide, i) {
            var img = slide.querySelector('img');
            var alt = String((img && img.getAttribute('alt')) || '').trim().toLowerCase().replace(/^the /, '');
            if (alt.indexOf(want) === 0) {
              index = i;
              return true;
            }
            return false;
          });
          if (index >= 0) show.select(index, undefined, { animate: true });
        }

        /* ---------- Per-unit color picks ---------- */

        paintDots() {
          this.querySelectorAll('.cb-bo__pick').forEach(function (pick) {
            var select = pick.querySelector('select');
            var dot = pick.querySelector('.cb-bo__pick-dot');
            var opt = select && select.options[select.selectedIndex];
            var color = opt ? opt.getAttribute('data-color') : '';
            var image = opt ? opt.getAttribute('data-image') : '';
            if (!dot) return;
            dot.classList.toggle('cb-bo__pick-dot--img', !!image);
            if (image) dot.style.setProperty('--cb-dot', 'center / cover no-repeat url("' + image + '")');
            else if (color) dot.style.setProperty('--cb-dot', color);
            else dot.removeAttribute('style');
          });
        }

        setAllPicks(id) {
          var changed = false;
          this.querySelectorAll('.cb-bo__pick-select').forEach(function (select) {
            var opt = select.querySelector('option[value="' + id + '"]');
            if (opt && !opt.disabled && select.value !== String(id)) {
              select.value = String(id);
              changed = true;
            }
          });
          if (changed) this.paintDots();
          this.querySelectorAll('[data-unit]:not([data-unit="1"]) .cb-bo__swatch-input[value="' + id + '"]').forEach(function (r) {
            if (!r.disabled) r.checked = true;
          });
        }

        // Rows: every pack's unit 1 menu shows the product's current color.
        setUnitOneSelects(id) {
          this.querySelectorAll('.cb-bo__pick-select[data-unit-n="1"]').forEach(function (select) {
            var opt = select.querySelector('option[value="' + id + '"]');
            if (opt && !opt.disabled) select.value = String(id);
          });
        }

        // Every pack's unit 1 shows the product's current color.
        setUnitOne(id) {
          this.querySelectorAll('[data-unit="1"] .cb-bo__swatch-input[value="' + id + '"]').forEach(function (r) {
            if (!r.disabled) r.checked = true;
          });
        }

        // 2- and 3-pack photos from layered cutouts (data-cb-stack maps variant id to src/srcset):
        // each layer shows its unit's picked color.
        paintStacks() {
          this.querySelectorAll('.cb-bo__img[data-cb-stack]').forEach(function (box) {
            var map;
            try {
              map = JSON.parse(box.getAttribute('data-cb-stack') || '{}');
            } catch (e) {
              return;
            }
            var item = box.closest('.cb-bo__item');
            if (!item) return;
            box.querySelectorAll('img[data-unit-n]').forEach(function (img) {
              var n = img.getAttribute('data-unit-n');
              var select = item.querySelector('.cb-bo__pick-select[data-unit-n="' + n + '"]');
              var swatch = item.querySelector('[data-unit="' + n + '"] .cb-bo__swatch-input:checked');
              var art = map[select ? select.value : swatch ? swatch.value : ''];
              if (!art || img.getAttribute('src') === art.src) return;
              img.srcset = art.srcset;
              img.src = art.src;
            });
          });
        }

        // Fetch the other colors' cutouts once the page has settled, so a color pick swaps instantly.
        warmStacks() {
          var seen = {};
          this.querySelectorAll('.cb-bo__img[data-cb-stack]').forEach(function (box) {
            var map;
            try {
              map = JSON.parse(box.getAttribute('data-cb-stack') || '{}');
            } catch (e) {
              return;
            }
            var sizes = box.querySelector('img') ? box.querySelector('img').getAttribute('sizes') : '';
            Object.keys(map).forEach(function (id) {
              var art = map[id];
              if (!art || seen[art.src]) return;
              seen[art.src] = true;
              var img = new Image();
              img.decoding = 'async';
              if (sizes) img.sizes = sizes;
              img.srcset = art.srcset;
              img.src = art.src;
            });
          });
        }

        // Card art follows unit 1's color (data-cb-art maps variant id to src/srcset).
        setArt(id) {
          this.querySelectorAll('.cb-bo__img[data-cb-art]').forEach(function (box) {
            var map;
            try {
              map = JSON.parse(box.getAttribute('data-cb-art') || '{}');
            } catch (e) {
              return;
            }
            var art = map[String(id)];
            var img = box.querySelector('img');
            if (!art || !img || img.getAttribute('src') === art.src) return;
            img.srcset = art.srcset;
            img.src = art.src;
          });
        }

        // Unit 1 changed: select the same color in Horizon's (hidden) picker so the gallery, URL,
        // price and form variant update exactly as if the shopper had used it.
        driveVariant(option) {
          if (!option) return;
          var picker = this.scope().querySelector('variant-picker');
          if (!picker) return;
          var radio = Array.prototype.find.call(picker.querySelectorAll('input[type="radio"]'), function (r) {
            return r.value === option;
          });
          if (radio) {
            if (radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var select = Array.prototype.filter.call(picker.querySelectorAll('select'), function (s) {
            return Array.prototype.some.call(s.options, function (o) {
              return o.value === option;
            });
          })[0];
          if (select && select.value !== option) {
            select.value = option;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // The checked pack's picks, or [] when no pack with picks is selected.
        activePicks() {
          var checked = this.querySelector('.cb-bo__input:checked');
          var item = checked ? checked.closest('.cb-bo__item') : null;
          var tray = item ? item.querySelector('.cb-bo__picks') : null;
          if (!tray) return [];
          var input = this.qtyInput();
          var qty = parseInt(checked.value, 10) || 1;
          if (input && parseInt(input.value, 10) !== qty) return [];
          var self = this;
          var sizeOf = function (n) {
            var s = tray.querySelector('.cb-bo__size-select[data-unit-n="' + n + '"]');
            return s ? s.value : '';
          };
          var named = function (color, n) {
            return [color, sizeOf(n) ? self.sizeLabel() + ' ' + sizeOf(n) : ''].filter(Boolean).join(' ');
          };
          var units = tray.querySelectorAll('[data-unit]');
          if (units.length) {
            return Array.prototype.map.call(units, function (unit) {
              var r = unit.querySelector('.cb-bo__swatch-input:checked');
              return r ? { id: r.value, name: named(r.getAttribute('data-name') || '', unit.getAttribute('data-unit')) } : null;
            }).filter(Boolean);
          }
          var colors = tray.querySelectorAll('.cb-bo__pick-select');
          if (!colors.length) {
            // One color: each unit's size menu names its variant.
            return Array.prototype.map.call(tray.querySelectorAll('.cb-bo__size-select'), function (select) {
              return { id: self.sizeVariant(select.value), name: named('', select.getAttribute('data-unit-n')) };
            }).filter(function (p) {
              return p.id;
            });
          }
          return Array.prototype.map.call(colors, function (select) {
            var opt = select.options[select.selectedIndex];
            return { id: select.value, name: named(opt ? opt.getAttribute('data-name') : '', select.getAttribute('data-unit-n')) };
          });
        }

        sizeLabel() {
          var row = this.querySelector('.cb-size__label');
          var text = row ? row.firstChild && row.firstChild.nodeValue : '';
          return (text || 'Size:').replace(/:\s*$/, '').trim() || 'Size';
        }

        // Cart lines for the picks, or null when the normal form already adds the same thing.
        mixLines() {
          var picks = this.activePicks();
          if (!picks.length) return null;
          var order = [];
          var byId = {};
          picks.forEach(function (pick) {
            var id = pick.id;
            if (!byId[id]) {
              byId[id] = { id: id, quantity: 0, name: pick.name };
              order.push(id);
            }
            byId[id].quantity += 1;
          });
          var lines = order.map(function (id) {
            return byId[id];
          });
          if (lines.length === 1 && String(lines[0].id) === String(this.formVariantId())) return null;
          return lines;
        }

        syncMix() {
          this.paintStacks();
          var lines = this.mixLines();
          var scope = this.scope();
          if (scope.classList) scope.classList.toggle('cb-bo-mixed', !!lines);
          this.syncSticky(lines);
        }

        onSubmit(event) {
          var form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (!form.closest('product-form-component') || !this.scope().contains(form)) return;
          var lines = this.mixLines();
          // 2026-10-13: Theme settings > Add to cart flow > straight to checkout. The pack (one line per color)
          // goes in, then the conversion layer makes the cart right (gift, no protection) and opens checkout.
          if (this.dataset.directCheckout === 'true' && typeof window.cbGoCheckout === 'function') {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!lines) {
              var input = this.qtyInput();
              lines = [{ id: this.formVariantId(), quantity: (input && parseInt(input.value, 10)) || 1 }];
            }
            this.goCheckout(lines);
            return;
          }
          // 2026-10-12: no refill row in the buy box any more; the cart's Add card offers the refill.
          if (!lines) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addLines(lines, form);
        }

        goCheckout(lines) {
          var self = this;
          var error = this.querySelector('.cb-bo__error');
          if (error) error.hidden = true;
          if (this.busy) return;
          this.busy = true;
          // Back from checkout can restore this page from the back-forward cache with busy still set, and every tap
          // after that would be swallowed (only the button's tick shows). Clear it whenever the page is shown again,
          // and after 12 s at most (a navigation that never happened).
          if (!this.onPageShow) {
            this.onPageShow = function () {
              self.busy = false;
            };
            window.addEventListener('pageshow', this.onPageShow);
          }
          clearTimeout(this.busyTimer);
          this.busyTimer = setTimeout(function () {
            self.busy = false;
          }, 12000);
          window.cbGoCheckout(lines.map(function (l) {
            return { id: l.id, quantity: l.quantity };
          })).catch(function (err) {
            self.busy = false;
            if (!error) return;
            error.textContent = (err && err.message) || 'That could not be added. Please try again.';
            error.hidden = false;
          });
        }

        addLines(lines, form) {
          var self = this;
          var error = this.querySelector('.cb-bo__error');
          if (error) error.hidden = true;
          if (this.busy) return;
          this.busy = true;
          var plain = lines.map(function (l) {
            return { id: l.id, quantity: l.quantity };
          });
          var job;
          if (typeof window.cbAddLines === 'function') {
            job = window.cbAddLines(plain, form);
          } else {
            // No conversion layer on the page: add through the AJAX API, then show the cart.
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            job = fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: plain.map(function (l) {
                  return { id: Number(l.id), quantity: l.quantity };
                })
              })
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (res) {
                if (res && res.status) throw new Error(res.description || res.message || '');
                window.location.href = root + 'cart';
              });
          }
          Promise.resolve(job)
            .catch(function (err) {
              if (!error) return;
              error.textContent = (err && err.message) || 'Those colors could not be added. Please try again.';
              error.hidden = false;
            })
            .then(function () {
              self.busy = false;
            });
        }

        // "Size M", or "Mixed sizes" for a pack whose units differ.
        packSizeText(item) {
          var names = this.unitSizes(item).filter(Boolean).map(function (z) {
            return z.name;
          });
          var one = names.length && names.every(function (x) {
            return x === names[0];
          });
          return one ? this.sizeLabel() + ' ' + names[0] : 'Mixed ' + this.sizeLabel().toLowerCase() + 's';
        }

        /* ---------- Sticky bar summary ---------- */

        syncSticky(lines) {
          var sticky = this.scope().querySelector('sticky-add-to-cart');
          if (!sticky) return;
          var checked = this.querySelector('.cb-bo__input:checked');
          var card = checked ? checked.closest('.cb-bo__card') : null;
          var qty = checked ? parseInt(checked.value, 10) || 1 : 1;
          var bundled = !!card && qty > 1;
          // Any pick that differs from the form (two colors, or one other color) is spelled out.
          var mixed = bundled && !!lines;
          var info = sticky.querySelector('.sticky-add-to-cart__info');
          var offer = info ? info.querySelector('.cb-sticky-offer') : null;
          var totalBox = sticky.querySelector('.cb-sticky-total');
          var total = card ? card.querySelector('.cb-bo__total') : null;

          sticky.classList.toggle('cb-sticky--bundled', bundled && !!total);
          sticky.classList.toggle('cb-sticky--mixed', mixed);

          // 2026-10-12, like deskboardbuddy and myfirehome: the button just says "Add to cart →"
          // (the arrow is CSS on .cb-sticky-arrow) and the price sits in a small line beside the
          // photo: the picked pack's total in bold, then the struck price (a pack's one-at-a-time
          // total, or one unit's after-launch price).
          var btnText = sticky.querySelector('.sticky-add-to-cart__button .add-to-cart-text__content');
          if (btnText && !btnText.querySelector('.cb-sticky-arrow')) {
            var arrow = document.createElement('span');
            arrow.className = 'cb-sticky-arrow';
            arrow.setAttribute('aria-hidden', 'true');
            btnText.appendChild(arrow);
          }
          if (totalBox) totalBox.remove();

          var line = info ? info.querySelector('.cb-sticky-line') : null;
          if (info && total) {
            if (!line) {
              line = document.createElement('p');
              line.className = 'cb-sticky-line';
              info.appendChild(line);
            }
            var regEl = card ? card.querySelector('.cb-bo__regular s') : null;
            var wasText = regEl ? regEl.textContent.trim() : (qty === 1 && this.dataset.wasSingle ? this.dataset.wasSingle : '');
            line.textContent = '';
            var now = document.createElement('strong');
            now.textContent = total.textContent.trim();
            line.appendChild(now);
            if (wasText) {
              var was = document.createElement('s');
              was.textContent = wasText;
              line.appendChild(was);
            }
            if (this.dataset.size) {
              var sizeTag = document.createElement('span');
              sizeTag.className = 'cb-sticky-size';
              sizeTag.textContent = this.packSizeText(card.closest('.cb-bo__item'));
              line.appendChild(sizeTag);
            }
          } else if (line) {
            line.remove();
          }

          if (!bundled) {
            if (offer) offer.remove();
            return;
          }

          if (info) {
            if (!offer) {
              offer = document.createElement('p');
              offer.className = 'cb-sticky-offer';
              info.insertBefore(offer, line || null);
            }
            var text = card.getAttribute('data-cb-title') || '';
            if (this.dataset.size && !mixed) text += ', ' + this.packSizeText(card.closest('.cb-bo__item')).toLowerCase();
            if (mixed) {
              text += ': ' + lines.map(function (l) {
                return l.quantity + ' ' + l.name;
              }).join(', ');
            } else if (card.getAttribute('data-cb-save')) {
              text += ', save ' + card.getAttribute('data-cb-save');
            }
            // 2026-10-17 (Nicholas: the free spares are the advantage): the pack's gift line too, e.g.
            // "2-pack, save $14 + 2 FREE spare caterpillars", without its emoji.
            var gift = !mixed && card.querySelector('.cb-bo__gift');
            if (gift) {
              var giftCopy = gift.cloneNode(true);
              giftCopy.querySelectorAll('.cb-bo__gift-emoji, svg').forEach(function (n) { n.remove(); });
              var giftText = giftCopy.textContent.replace(/\s+/g, ' ').trim();
              if (giftText) text += ' ' + giftText;
            }
            offer.textContent = text;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cb-launch-price"] && !Shopify.designMode) return;
  try {
    // The seasonal line (catalog/holidays.json): the line whose window holds today's Eastern date, none otherwise.
  (function () {
    function seasons() {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' })
        .format(new Date())
        .replace(/[^0-9]/g, '');
      var today = parseInt(parts, 10);
      document.querySelectorAll('.cb-launch__season[data-cb-seasons]').forEach(function (el) {
        var hit = '';
        el.getAttribute('data-cb-seasons').split(/\n/).some(function (line) {
          var p = line.trim().split('|');
          if (p.length === 3 && +p[0] <= today && today <= +p[1]) {
            hit = p[2];
            return true;
          }
          return false;
        });
        el.textContent = hit;
        el.hidden = !hit;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', seasons);
    else seasons();
  })();

  if (window.customElements && !window.customElements.get('cb-launch-price')) {
    window.customElements.define(
      'cb-launch-price',
      class extends HTMLElement {
        connectedCallback() {
          var d = this.dataset;
          var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d.endDate || '');
          var t = /^(\d{1,2}):(\d{2})$/.exec(d.endTime || '');
          if (!m || !t) {
            this.endLaunch();
            return;
          }
          this.end = this.etToEpoch(+m[1], +m[2], +m[3], +t[1], +t[2]);
          this.tick = this.tick.bind(this);
          this.tick();
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
        }

        // Launch over: the row style keeps the price and drops the struck price and pill;
        // the other styles hide entirely.
        endLaunch() {
          if (this.classList.contains('cb-launch--row')) {
            this.querySelectorAll('[data-cb-launch-extra]').forEach(function (el) {
              el.hidden = true;
            });
          } else {
            this.hidden = true;
          }
        }

        // Wall-clock time in America/New_York to an epoch, DST-aware.
        etToEpoch(y, mo, da, h, mi) {
          var fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: 'numeric',
            day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
          });
          var offsetAt = function (ms) {
            var p = {};
            fmt.formatToParts(new Date(ms)).forEach(function (x) { if (x.type !== 'literal') p[x.type] = +x.value; });
            if (p.hour === 24) p.hour = 0;
            return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(ms / 1000) * 1000;
          };
          var guess = Date.UTC(y, mo - 1, da, h, mi, 0);
          var o1 = offsetAt(guess);
          var o2 = offsetAt(guess - o1);
          return guess - (o1 === o2 ? o1 : o2);
        }

        tick() {
          clearTimeout(this.timer);
          var left = this.end - Date.now();
          if (!(left > 0)) {
            this.endLaunch();
            return;
          }
          var mins = Math.ceil(left / 60000);
          var days = Math.floor(mins / 1440);
          var hours = Math.floor((mins % 1440) / 60);
          var m = mins % 60;
          var text = days > 0 ? days + 'd ' + hours + 'h ' + (m < 10 ? '0' : '') + m + 'm' : hours > 0 ? hours + 'h ' + m + 'm' : m + 'm';
          var out = this.querySelector('[data-cb-left]');
          if (out) out.textContent = text;
          this.timer = setTimeout(this.tick, Math.min(30000, Math.max(1000, left % 60000 || 60000)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    if (window.customElements && !window.customElements.get('cb-delivery-countdown')) {
    // CORE START (pure date math; also unit-tested outside the browser)
    var CB_DAY = 86400000;
    var cbFormatters = {};

    // Wall-clock parts of an instant in an IANA time zone.
    var cbParts = function (ms, tz) {
      var f = cbFormatters[tz];
      if (!f) {
        f = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          hourCycle: 'h23',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric'
        });
        cbFormatters[tz] = f;
      }
      var out = {};
      f.formatToParts(new Date(ms)).forEach(function (p) {
        if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10);
      });
      if (out.hour === 24) out.hour = 0;
      return out;
    };

    // Offset (ms) between wall-clock time in tz and UTC at a given instant.
    var cbOffset = function (ms, tz) {
      var t = Math.floor(ms / 1000) * 1000;
      var p = cbParts(t, tz);
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - t;
    };

    // Instant (epoch ms) of a wall-clock time in tz. Two passes handle DST changes.
    var cbZonedToEpoch = function (y, m, d, h, mi, tz) {
      var guess = Date.UTC(y, m - 1, d, h, mi, 0);
      var off = cbOffset(guess, tz);
      var t = guess - off;
      var off2 = cbOffset(t, tz);
      return off2 === off ? t : guess - off2;
    };

    // Calendar dates are whole day numbers (days since 1970-01-01).
    var cbDayNum = function (y, m, d) {
      return Math.round(Date.UTC(y, m - 1, d) / CB_DAY);
    };

    var cbIsBiz = function (dn, hol) {
      var wd = (((dn + 4) % 7) + 7) % 7; // 0 = Sunday, 6 = Saturday
      return wd !== 0 && wd !== 6 && !hol[dn];
    };

    var cbNextBiz = function (dn, hol) {
      for (var i = 0; i < 400; i++) {
        dn += 1;
        if (cbIsBiz(dn, hol)) return dn;
      }
      return dn;
    };

    var cbAddBiz = function (dn, n, hol) {
      for (var i = 0; n > 0 && i < 800; i++) {
        dn += 1;
        if (cbIsBiz(dn, hol)) n -= 1;
      }
      return dn;
    };

    var cbParseHolidays = function (text) {
      var hol = {};
      String(text || '')
        .split(/[\s,;]+/)
        .forEach(function (s) {
          var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
          if (m) hol[cbDayNum(+m[1], +m[2], +m[3])] = true;
        });
      return hol;
    };

    // c = { tz, cutH, cutM, procMin, procMax, transitMin, transitMax, hol }
    var cbCompute = function (now, c) {
      var p = cbParts(now, c.tz);
      var today = cbDayNum(p.year, p.month, p.day);
      var cut = cbZonedToEpoch(p.year, p.month, p.day, c.cutH, c.cutM, c.tz);
      var received = today;
      if (!(cbIsBiz(today, c.hol) && now < cut)) {
        received = cbNextBiz(today, c.hol);
        var r = new Date(received * CB_DAY);
        cut = cbZonedToEpoch(r.getUTCFullYear(), r.getUTCMonth() + 1, r.getUTCDate(), c.cutH, c.cutM, c.tz);
      }
      var ship = cbAddBiz(received, c.procMax, c.hol);
      return {
        deadline: cut,
        msLeft: cut - now,
        ship: ship,
        arriveMin: cbAddBiz(cbAddBiz(received, c.procMin, c.hol), c.transitMin, c.hol),
        arriveMax: cbAddBiz(ship, c.transitMax, c.hol)
      };
    };

    // Time left as "3h 12m" (or "12m" in the last hour). Rounded up, never below 1m.
    var cbLeft = function (ms) {
      var mins = Math.max(1, Math.ceil(ms / 60000));
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      return h > 0 ? h + 'h ' + m + 'm' : m + 'm';
    };
    // CORE END

    // Fill a template like "Order within {countdown}" without using innerHTML.
    var cbFill = function (el, tpl, values) {
      el.textContent = '';
      String(tpl || '')
        .split(/(\{[a-z_]+\})/)
        .forEach(function (piece) {
          if (!piece) return;
          var key = piece.charAt(0) === '{' ? piece.slice(1, -1) : null;
          if (key && Object.prototype.hasOwnProperty.call(values, key)) {
            var b = document.createElement('strong');
            b.textContent = values[key];
            el.appendChild(b);
          } else {
            el.appendChild(document.createTextNode(piece));
          }
        });
    };

    var cbInt = function (v, fallback) {
      var n = parseInt(v, 10);
      return isNaN(n) ? fallback : n;
    };

    window.customElements.define(
      'cb-delivery-countdown',
      class extends HTMLElement {
        connectedCallback() {
          var d = this.dataset;
          var pMin = cbInt(d.procMin, 1);
          var pMax = cbInt(d.procMax, 3);
          var tMin = cbInt(d.transitMin, 2);
          var tMax = cbInt(d.transitMax, 5);
          this.cfg = {
            tz: d.timezone || 'America/New_York',
            cutH: cbInt(d.cutoffHour, 14),
            cutM: cbInt(d.cutoffMinute, 0),
            procMin: Math.min(pMin, pMax),
            procMax: Math.max(pMin, pMax),
            transitMin: Math.min(tMin, tMax),
            transitMax: Math.max(tMin, tMax),
            hol: cbParseHolidays(d.holidays),
            withinMs: cbInt(d.countdownWithin, 24) * 3600000,
            countdown: d.showCountdown === 'true',
            delivery: d.showDelivery === 'true',
            calendar: d.arriveMode === 'calendar',
            calMin: cbInt(d.calMin, 8),
            calMax: cbInt(d.calMax, 15)
          };
          var locale = d.locale || 'en-US';
          var isLong = d.dateStyle === 'long';
          try {
            this.dateFmt = new Intl.DateTimeFormat(locale, {
              timeZone: 'UTC',
              weekday: isLong ? 'long' : 'short',
              month: isLong ? 'long' : 'short',
              day: 'numeric'
            });
            this.timeFmt = new Intl.DateTimeFormat(locale, {
              timeZone: this.cfg.tz,
              hour: 'numeric',
              minute: '2-digit',
              timeZoneName: 'short'
            });
            this.shortFmt = new Intl.DateTimeFormat(locale, {
              timeZone: 'UTC',
              month: 'short',
              day: 'numeric'
            });
          } catch (e) {
            return; // Invalid locale or time zone: keep the static server-rendered text.
          }
          this.boundUpdate = this.update.bind(this);
          document.addEventListener('visibilitychange', this.boundUpdate);
          this.update();
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          if (this.boundUpdate) document.removeEventListener('visibilitychange', this.boundUpdate);
        }

        update() {
          clearTimeout(this.timer);
          var r;
          try {
            r = cbCompute(Date.now(), this.cfg);
            if (this.cfg.calendar) {
              // Calendar mode: arrival = order date + N calendar days, as the shipping
              // policy states it. Never show an arrival date before the ship-by date.
              // The order date rolls over at the daily cutoff, every day of the week, and the
              // compact countdown runs to that same moment.
              var now = Date.now();
              var cp = cbParts(now, this.cfg.tz);
              var orderDay = cbDayNum(cp.year, cp.month, cp.day);
              var dayCut = cbZonedToEpoch(cp.year, cp.month, cp.day, this.cfg.cutH, this.cfg.cutM, this.cfg.tz);
              if (now >= dayCut) {
                orderDay += 1;
                var nd = new Date(orderDay * CB_DAY);
                dayCut = cbZonedToEpoch(nd.getUTCFullYear(), nd.getUTCMonth() + 1, nd.getUTCDate(), this.cfg.cutH, this.cfg.cutM, this.cfg.tz);
              }
              r.calLeft = dayCut - now;
              var cMin = Math.min(this.cfg.calMin, this.cfg.calMax);
              var cMax = Math.max(this.cfg.calMin, this.cfg.calMax);
              r.arriveMin = Math.max(orderDay + cMin, r.ship);
              r.arriveMax = Math.max(orderDay + cMax, r.arriveMin);
            }
          } catch (e) {
            return;
          }
          var self = this;
          var d = this.dataset;
          var fmt = function (dn) {
            return self.dateFmt.format(new Date(dn * CB_DAY));
          };
          var values = {
            countdown: cbLeft(r.msLeft),
            ship_date: fmt(r.ship),
            arrive_min: fmt(r.arriveMin),
            arrive_max: fmt(r.arriveMax),
            cutoff_time: this.timeFmt.format(new Date(r.deadline))
          };
          var ticking = this.cfg.countdown && r.msLeft <= this.cfg.withinMs;
          // Compact layout: "arrives Oct 14 to 21" (the month repeats only when it changes).
          var compactEl = this.querySelector('[data-cb-compact]');
          var compactLeft = this.cfg.calendar && r.calLeft != null ? r.calLeft : r.msLeft;
          var compactTicking = this.cfg.countdown && d.tplCompactCountdown && compactLeft <= this.cfg.withinMs;
          if (compactEl && d.tplCompact) {
            var dMin = new Date(r.arriveMin * CB_DAY);
            var dMax = new Date(r.arriveMax * CB_DAY);
            var range = self.shortFmt.format(dMin);
            if (r.arriveMax !== r.arriveMin) {
              range += ' to ' + (dMin.getUTCMonth() === dMax.getUTCMonth() ? String(dMax.getUTCDate()) : self.shortFmt.format(dMax));
            }
            cbFill(compactEl, compactTicking ? d.tplCompactCountdown : d.tplCompact, {
              countdown: cbLeft(compactLeft),
              arrive_range: range,
              arrive_min: self.shortFmt.format(dMin),
              arrive_max: self.shortFmt.format(dMax),
              ship_date: self.shortFmt.format(new Date(r.ship * CB_DAY))
            });
          }
          var shipEl = this.querySelector('[data-cb-ship]');
          var arriveEl = this.querySelector('[data-cb-arrive]');
          if (shipEl) cbFill(shipEl, ticking ? d.tplCountdown : d.tplPlain, values);
          if (arriveEl && this.cfg.delivery) cbFill(arriveEl, d.tplDelivery, values);

          // Timeline layout: Ordered (today) > Ships (by date) > Arrives (date range).
          var tl = this.querySelector('.cb-dc__tl');
          if (tl) {
            var lead = this.querySelector('[data-cb-lead]');
            if (lead) lead.hidden = !ticking;
            var p = cbParts(Date.now(), this.cfg.tz);
            var sf = function (dn) {
              return self.shortFmt.format(new Date(dn * CB_DAY));
            };
            var tv = {
              today: sf(cbDayNum(p.year, p.month, p.day)),
              ship_date: sf(r.ship),
              arrive_min: sf(r.arriveMin),
              arrive_max: sf(r.arriveMax)
            };
            var pairs = [
              ['[data-cb-tl-order]', d.tplTlOrder],
              ['[data-cb-tl-ship]', d.tplTlShip],
              ['[data-cb-tl-arrive]', d.tplTlArrive]
            ];
            pairs.forEach(function (pair) {
              var el = self.querySelector(pair[0]);
              if (el && pair[1]) cbFill(el, pair[1], tv);
            });
          }
          this.setAttribute('data-ready', '');
          // Re-check every 30 seconds, and right after the cutoff passes.
          var nextLeft = r.calLeft != null ? Math.min(r.msLeft, r.calLeft) : r.msLeft;
          this.timer = setTimeout(this.boundUpdate, Math.max(1000, Math.min(30000, nextLeft + 500)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
